import React, { useEffect, useState } from "react";
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Container,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Row,
  Col
} from "reactstrap";
import {Link, useLocation} from 'react-router-dom';


const SurahSubMenuGrid = ({start,stop, closeDropdown}) => {
  // Generate 114 elements for the submenu
  const submenuItems = Array.from({ length: stop - start + 1 }, (_, index) => index + start);

  return (
    <div className="submenu">
      <Container>
        <Row>
          {submenuItems.map((item) => (
            <Col key={item} xs="12" sm="6" md="4" lg="3">
              <Link
                to={`/surah-list/${item}`}
                style={{ textDecoration: "none", color: "inherit", margin:0, padding:0 }}
                onClick={closeDropdown}
              >
                <p>{`Surah ${item}`}</p>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

const CustomSubMenuGrid = ({closeDropdown, customMenuItems}) => {
  return (
    <div className="submenu">
      <Container>
      {customMenuItems.map((item) => (
            <Link
            to={item.link}
            style={{ textDecoration: "none", color: "inherit", margin:0, padding:0 }}
            onClick={closeDropdown}
          >
            <p>{item.name}</p>
          </Link>
          ))}
      </Container>
    </div>
  );
};

const defaultState = {
  surahs_1_60: false,
  surahs_61_114:false
}
const NavbarPage = ({ navItems }) => {
  const { pathname } = useLocation();
  const [isDarkThemeEnabled, setDarkThemeEnabled] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState({...defaultState});

  const [state, setState] = useState({
    isOpenMenu: false,
    navClass : "is-sticky"
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(()=>{
    if(localStorage.getItem("choosedTheme") === 'dark'){
      document.body.setAttribute("data-bs-theme", "dark");
      setDarkThemeEnabled(true)
    }else{
      document.body.setAttribute("data-bs-theme", "light");
      setDarkThemeEnabled(false)
    }

    // By default change to blue theme
    document.getElementById("colorTheme").href =
      "assets/css/colors/" + "blue" + ".css";
  },[]);
  
  const toggle = () => {
    setState({ isOpenMenu: !state.isOpenMenu });
  };

  const toggleDropdown = (idnm) => {
    setIsDropdownOpen({
      ...defaultState,
      [idnm]: !isDropdownOpen[idnm],
    });
  };

  const closeDropdown = () => {
    setIsDropdownOpen({...defaultState});
  };

  const toggleTheme = (e) => {
    setDarkThemeEnabled(e.target.checked);
    toggleThem();
  }

  const toggleThem = () => {
    if (document.body.getAttribute("data-bs-theme") === "light") {
      document.body.setAttribute("data-bs-theme", "dark");
      localStorage.setItem("choosedTheme",'dark');
    } else {
      document.body.setAttribute("data-bs-theme", "light");
      localStorage.setItem("choosedTheme",'light');
    }
  };

    return (
      <React.Fragment>
        <div id="navbar" className={state.navClass}>
          <nav className="navbar navbar-expand-lg navbar-custom sticky sticky-dark">
            <Container>
              <label class="switch custom-switch">
                <input
                  type="checkbox"
                  id="theme-switcher"
                  onClick={toggleTheme}
                  checked={isDarkThemeEnabled}
                />
                <span class="slider round"></span>
              </label>
              <NavbarBrand className="logo text-uppercase" href="/">
                Quran 411
              </NavbarBrand>
              <NavbarToggler onClick={toggle}>
                <i className="mdi mdi-menu"></i>
              </NavbarToggler>

              <Collapse id="navbarCollapse" isOpen={state.isOpenMenu} navbar>
                <Nav navbar className="navbar-center" id="mySidenav">
                  {navItems.map((item, key) => (
                    <NavItem
                      key={key}
                      className={item.navheading === "Home" ? "active" : ""}
                      onMouseEnter={() => toggleDropdown(item.idnm)}
                      onMouseLeave={closeDropdown}
                      onClick={() => toggleDropdown(item.idnm)}
                    >
                      {item.subMenu ? (
                        <Dropdown
                          nav
                          isOpen={isDropdownOpen[item.idnm]}
                          toggle={() => toggleDropdown(item.idnm)}
                        >
                          <DropdownToggle nav caret>
                            {item.navheading}
                          </DropdownToggle>
                          <DropdownMenu className={item.custom ? "customSubNav": "subnav"}>
                            {
                              !item.custom ?
                                <SurahSubMenuGrid
                                  start={item.start}
                                  stop={item.stop}
                                  closeDropdown={closeDropdown}
                                />
                                :
                                <CustomSubMenuGrid
                                  customMenuItems={item.customMenuItem}
                                  closeDropdown={closeDropdown}
                                />
                            }
                          </DropdownMenu>
                        </Dropdown>
                      ) : (
                        <NavLink href={item.link}>
                          {item.navheading}
                        </NavLink>
                      )}
                    </NavItem>
                  ))}
                </Nav>
              </Collapse>
            </Container>
          </nav>
        </div>
      </React.Fragment>
    );
  
}

export default NavbarPage;
